/**
 * Pythagorean letter→digit maps for Russian (Cyrillic) and English (Latin).
 * Russian numerology follows a 1..9 cyclic mapping of the Russian alphabet
 * order (skipping the soft/hard signs initially, then placing them as
 * appropriate). English follows the canonical Pythagorean A=1..I=9, J=1...
 *
 * Used for the "expression number" (число имени).
 */
export const RU_LETTER_VALUES = {
    а: 1, б: 2, в: 3, г: 4, д: 5, е: 6, ё: 7, ж: 8, з: 9,
    и: 1, й: 2, к: 3, л: 4, м: 5, н: 6, о: 7, п: 8, р: 9,
    с: 1, т: 2, у: 3, ф: 4, х: 5, ц: 6, ч: 7, ш: 8, щ: 9,
    ъ: 1, ы: 2, ь: 3, э: 4, ю: 5, я: 6,
};
export const EN_LETTER_VALUES = {
    a: 1, j: 1, s: 1,
    b: 2, k: 2, t: 2,
    c: 3, l: 3, u: 3,
    d: 4, m: 4, v: 4,
    e: 5, n: 5, w: 5,
    f: 6, o: 6, x: 6,
    g: 7, p: 7, y: 7,
    h: 8, q: 8, z: 8,
    i: 9, r: 9,
};
/**
 * Sum letter values for a full name (any script). Non-letter chars and
 * unknown letters contribute 0. Russian and English mix transparently —
 * useful for transliterated names.
 */
export function lettersToNumber(text) {
    let sum = 0;
    for (const ch of text.toLowerCase()) {
        sum += RU_LETTER_VALUES[ch] ?? EN_LETTER_VALUES[ch] ?? 0;
    }
    return sum;
}
//# sourceMappingURL=pythagorean.js.map